import { RefrigerantCode } from '../types';

export interface RefrigerantProperties {
  maxOperatingTempC: number;
  minOperatingTempC: number;
  maxOperatingPressureKpa: number;
  minOperatingPressureKpa: number;
}

export const refrigerantProperties: Record<RefrigerantCode, RefrigerantProperties> = {
  [RefrigerantCode.R22]: {
    maxOperatingTempC: 60,
    minOperatingTempC: -40,
    maxOperatingPressureKpa: 2000,
    minOperatingPressureKpa: 100
  },
  [RefrigerantCode.R32]: {
    maxOperatingTempC: 65,
    minOperatingTempC: -40,
    maxOperatingPressureKpa: 3500,
    minOperatingPressureKpa: 200
  },
  [RefrigerantCode.R134a]: {
    maxOperatingTempC: 65,
    minOperatingTempC: -40,
    maxOperatingPressureKpa: 1500,
    minOperatingPressureKpa: 100
  },
  [RefrigerantCode.R404A]: {
    maxOperatingTempC: 60,
    minOperatingTempC: -40,
    maxOperatingPressureKpa: 2500,
    minOperatingPressureKpa: 150
  },
  [RefrigerantCode.R407C]: {
    maxOperatingTempC: 65,
    minOperatingTempC: -40,
    maxOperatingPressureKpa: 2000,
    minOperatingPressureKpa: 100
  },
  [RefrigerantCode.R410A]: {
    maxOperatingTempC: 70,
    minOperatingTempC: -40,
    maxOperatingPressureKpa: 3500,
    minOperatingPressureKpa: 200
  },
  [RefrigerantCode.R448A]: {
    maxOperatingTempC: 65,
    minOperatingTempC: -40,
    maxOperatingPressureKpa: 2500,
    minOperatingPressureKpa: 150
  },
  [RefrigerantCode.R449A]: {
    maxOperatingTempC: 65,
    minOperatingTempC: -40,
    maxOperatingPressureKpa: 2500,
    minOperatingPressureKpa: 150
  },
  [RefrigerantCode.R513A]: {
    maxOperatingTempC: 65,
    minOperatingTempC: -40,
    maxOperatingPressureKpa: 2000,
    minOperatingPressureKpa: 100
  },
  [RefrigerantCode.R1234yf]: {
    maxOperatingTempC: 65,
    minOperatingTempC: -40,
    maxOperatingPressureKpa: 1200,
    minOperatingPressureKpa: 80
  }
}; 